define('LNRS/Components/Jobs/JobSearchFilters',["jquery", "instantsearch", "Search/Search", "resourcerefinementlist", "eventManager", "Track/Events"], function ($, instantsearch, Search, resourceRefinementList, eventManager, events) {

    function JobsListing(args) {

        if (!args.isEditing) {

            if (!Search.configured) {
                Search.defaultConfig(args.algoliaAppId, args.algoliaApiKey, args.algoliaIndexName, 'en-US', args.clearFilterId, 'Clear Filters');
            }

            var locationFilter = instantsearch.widgets.refinementList({
                container: '#' + args.jobPostLocationId,
                attributeName: 'country',
                sortBy: ['name:asc'],
                operator: 'or',
                limit: 1000,
                templates: {
                    item: "<li class='job-location'>{{name}} <span class='number-of-items'>{{count}}</span></li>"
                },
                transformData: function (hit) {
                    return hit;
                },
                cssClasses: {
                    item: 'location-dropdown-item'
                }
            });
            Search.addWidget(locationFilter);

            var jobFamilyFacetWidget = instantsearch.widgets.refinementList({
                container: '#' + args.jobFamilyGroupId,
                attributeName: 'job_family_group',
                sortBy: ['name:asc', 'count:desc'],
                operator: 'or',
                limit: 1000,
                cssClasses: {
                    list: "search-filters-list-multiselect",
                    item: "search-filters-item-multiselect",
                    count: "search-filters-item-count-multiselect",
                    name: "search-filters-item-name-multiselect"
                }
            });
            Search.addWidget(jobFamilyFacetWidget);


            var brandFacetWidget = instantsearch.widgets.refinementList({
                container: '#' + args.brandId,
                attributeName: 'lnrs_brand',
                sortBy: ['name:asc', 'count:desc'],
                operator: 'or',
                cssClasses: {
                    list: "search-filters-list-multiselect",
                    item: "search-filters-item-multiselect",
                    count: "search-filters-item-count-multiselect",
                    name: "search-filters-item-name-multiselect"
                }
            });
            Search.addWidget(brandFacetWidget);

            var contractTypeFacetWidget = instantsearch.widgets.refinementList({
                container: '#' + args.contractTypeId,
                attributeName: 'contract_type',
                sortBy: ['name:asc', 'count:desc'],
                operator: 'or',
                cssClasses: {
                    list: "search-filters-list-multiselect",
                    item: "search-filters-item-multiselect",
                    count: "search-filters-item-count-multiselect",
                    name: "search-filters-item-name-multiselect"
                }
            });
            Search.addWidget(contractTypeFacetWidget);

            var jobTypeFacetWidget = instantsearch.widgets.refinementList({
                container: '#' + args.jobTypeId,
                attributeName: 'time_type_hiring_requirement',
                sortBy: ['name:asc', 'count:desc'],
                operator: 'or',
                cssClasses: {
                    list: "search-filters-list-multiselect",
                    item: "search-filters-item-multiselect",
                    count: "search-filters-item-count-multiselect",
                    name: "search-filters-item-name-multiselect"
                }
            });
            Search.addWidget(jobTypeFacetWidget);

            Search.firstTime = true;
            eventManager.subscribe(events.global.algoliaRendered, function (searchProvider) {
                selectCheckboxes();//initialize checkbox filters

                if (Search.firstTime) {//initialize location filter
                    Search.firstTime = false;
                    var selectedLocations = searchProvider.helper.lastResults._state.disjunctiveFacetsRefinements._country_state;
                    if (selectedLocations && selectedLocations.length) {

                        var haveInitSelections = false;
                        $('#' + args.jobPostLocationId).find('.job-location').each(function (index, element) {
                            $(selectedLocations).each(function (index, value) {
                                if ($(element).html().startsWith(value)) {

                                    var newElement = $('<span class="selected-item"><span class="selected-item-title">' + $(element).html() + '</span><a href="" class="remove remove-link"></a></span>');
                                    $('#' + args.jobPostLocationSelectedItemsId).append(newElement);

                                    haveInitSelections = true;

                                    $('.selected-placeholder', args.scope).remove();
                                }
                            });
                        });
                        if (haveInitSelections) {
                            $('.selected-placeholder', args.scope).remove();
                        }
                    }
                }
            });

            $(document).on("click", function (e, eventData) {
                var target = $(e.target);

                if (target.is("#_trackAnalytics")) { return };

                if (eventData && eventData.deselectClick) {
                    return;
                }

                var rootParentElement = target.closest('.job-location-filter');
                if (rootParentElement.length > 0) {//adding location filter

                    var locationText = target.html();
                    if ($(target).hasClass('number-of-items')) {
                        locationText = target.closest('.job-location').html();
                    }

                    var newElement = $('<span class="selected-item"><span class="selected-item-title">' + locationText + '</span><a href="" class="remove remove-link"></a></span>');
                    target.closest('.lnrs-filter-selected-options').find('.selected-items').append(newElement);

                    $('.selected-placeholder', args.scope).remove();
                }
                else {
                    var removeLink = target.closest('.remove-link');
                    if (removeLink.length > 0) {//removing location filter

                        var selectedItem = target.closest('.selected-item');
                        var selectedItemTitle = selectedItem.find('.selected-item-title');

                        $(selectedItem.closest('.lnrs-filter-selected-options').find('.job-location-filter').find('.job-location')).each(function (index, element) {

                            if ($(element).html() == selectedItemTitle.html()) {
                                var myEventData = new Object();
                                myEventData.deselectClick = true;

                                $(element).trigger('click', myEventData);
                                return false;
                            }
                        });

                        var containerForItems = selectedItem.closest('.selected-items');

                        selectedItem.remove();

                        var selectedItems = containerForItems.find('.selected-item');
                        if (selectedItems.length == 0) {
                            var newElement = $('<span class="selected-placeholder selected-item">' + args.locationPlaceholder + '</span>');
                            containerForItems.append(newElement);
                        }

                        e.stopPropagation();
                        e.preventDefault();
                    }
                }
            });

            Search.addWidget(
                instantsearch.widgets.clearAll({
                    container: '#' + args.clearFilterId,
                    templates: {
                        link: 'Clear all'
                    },
                    autoHideContainer: false
                })
            );

            Search.addWidget(
                instantsearch.widgets.stats({
                    container: '#searchStatisticsId',
                    templates: {
                        body: '{{#query}}{{#hasNoResults}}No results "{{query}}"{{/hasNoResults}}{{#hasOneResult}} Just one item "{{query}}"{{/hasOneResult}}{{#hasManyResults}}Text for many items "{{query}}"{{/hasManyResults}}{{/query}}'
                    }
                })
            );
        }
    }

    function selectCheckboxes() {
        $('.search-filters-item-multiselect').each(function () {
            if ($(this).find('input').attr("checked")) {
                $(this).find('label').addClass('filter-item-checked');
            }
            else {
                $(this).find('label').removeClass('filter-item-checked');
            }
        });
    }

    return function init(args) {
        
        return new JobsListing(args);
    };
});
